// -----------------------------------------------------------------------------
// Profile: Account-Einstellungen
// -----------------------------------------------------------------------------

import * as generalUtility from '../utility/generalUtility';

const init = () => {
  if ($('.js-body').hasClass('js-body-profile-my-account') === false) {
    return;
  }

  initEventListeners();
};

/**
 * Event-Listeners einrichten
 */
const initEventListeners = () => {
  $('.js-old-pw').focusout(function () {
    verifyOldPassword();
  });

  $('#frmPW').keyup(function () {
    checkPasswordStrength();
  });

  $('#frmPW2').keyup(function () {
    comparePasswords();
  });

  $('#frmSubmitMA').click(function (e) {
    e.preventDefault();
    $('#formMA').submit();
  });

  $('#frmSubmit5').click(function (e) {
    e.preventDefault();
    $('#form5').submit();
  });
};

/**
 * Prüft, ob Eingabe mit dem alten Passwort übereinstimmt
 */
const verifyOldPassword = () => {
  const $userEmail = $('.js-user-email');
  const $oldPassword = $('.js-old-pw');
  const $oldPwMessage = $('.js-old-pw-message');

  // Wert aus Formular holen
  let userEmail = $userEmail.val();
  let oldPassword = $oldPassword.val();

  if (oldPassword.length <= 0) {
    $oldPwMessage.hide();
    return;
  }

  $.ajax({
    method: 'POST',
    url: 'passwordCheck',
    data: { userEmail, oldPassword }
  })
    .done(function (dataStr) {
      const data = JSON.parse(dataStr);
      let message = '';

      // if: erfolgreich validiert
      // else: fehlerhaft validiert (PW falsch)
      if (data.isValid === true) {
        $('.js-old-pw').attr('data-valid', true);
      } else {
        message = $oldPwMessage.attr('data-failure-msg');
        $('.js-save-btn').prop('disabled', true);
        $('.js-old-pw').attr('data-valid', false);
      }
      $oldPwMessage.html(message).show();
    });
};

/**
 * Prüft die Stärke des neuen Passworts
 */
const checkPasswordStrength = () => {
  const basepath = $('.js-body').attr('data-basepath');
  const trans = generalUtility.getJsonFromHtml('.js-body-profile-my-account #trans');
  const $frmPw = $('#frmPW');

  // Bei leerem Eingabefeld Info an User nicht zeigen
  if ($frmPw.val().length <= 0) {
    $('.frmPW_message').hide();
    $('#frmSubmitMA').prop('disabled', true);
    return;
  }

  $.ajax({
    method: 'POST',
    url: `${basepath}/pw_check.php`,
    data: {
      PW: $frmPw.val()
    }
  })
    .done(function (strength) {
      let strengthMsg = '';
      const valid = generalUtility.strToBool($('.js-old-pw').attr('data-valid'));
      const validNewPw2 = generalUtility.strToBool($('.js-new-pw2').attr('data-valid'));

      if (strength < 4) {
        strengthMsg = trans.pw_zu_schwach;
        $('.js-new-pw').attr('data-valid', false);
        if (valid !== true) {
          $('#frmSubmitMA').prop('disabled', true);
        }
      } else {
        $('.js-new-pw').attr('data-valid', true);
        if (valid === true && validNewPw2 === true) {
          $('#frmSubmitMA').prop('disabled', false);
        }
      }
      $('.frmPW_message').html(strengthMsg).show();

      // Button-Status setzen (abhängig von Passwort-Vergleich)
      comparePasswords();
    });
};

/**
 * Passwort und Wiederholung des Passwortes vergleichen
 */
const comparePasswords = () => {
  const validOldPw = generalUtility.strToBool($('.js-old-pw').attr('data-valid'));
  const validNewPw = generalUtility.strToBool($('.js-new-pw').attr('data-valid'));

  if ($('#frmPW').val() !== $('#frmPW2').val()) {
    $('#frmSubmitMA').prop('disabled', true);
    $('.js-new-pw-2').attr('data-valid', false);
  } else {
    $('.js-new-pw-2').attr('data-valid', true);
    if (validOldPw === true && validNewPw === true) {
      $('#frmSubmitMA').prop('disabled', false);
    }
  }
};

export {
  init
};
